import React from "react"
import MuiAvatar from "@material-ui/core/Avatar"
import { Avatar, Icon } from ".."
import { useAuth } from "../../services"

const OperandioFallbackAvatar = ({ from, className }) => {
  const {
    settings: { organisation },
  } = useAuth()

  if (from) {
    return <Avatar {...from} className={className} />
  }
  if (organisation.logo) {
    return <Avatar avatar={{ key: organisation.logo }} fullName={organisation.name} className={className} />
  }
  return (
    <MuiAvatar style={{ backgroundColor: "#fff" }}>
      <Icon name="operandio" size={33} />
    </MuiAvatar>
  )
}

export default OperandioFallbackAvatar
